import { MsalGuardConfiguration, MsalInterceptorConfiguration } from '@azure/msal-angular';
import {
  BrowserCacheLocation,
  IPublicClientApplication,
  InteractionType,
  LogLevel,
  PublicClientApplication,
} from '@azure/msal-browser';

const FRONTEND_CLIENT = '7251ebaf-4a22-4999-9d12-2520a136f1e0';
const API_SCOPE       = 'api://3f8a6ff4-6a3f-44e7-9d18-d583d88ccfb7/access';
const TENANT_ID       = '72f2cfd5-459f-4d33-a195-03fc4807be8b';

export const CIAM_AUTHORITY = `https://ecs33budget.ciamlogin.com/${TENANT_ID}`;
export const AUTH_SCOPES    = { api: [API_SCOPE] };

export function msalInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId:              FRONTEND_CLIENT,
      authority:             CIAM_AUTHORITY,
      knownAuthorities:      ['ecs33budget.ciamlogin.com'],
      redirectUri:           window.location.origin,
      postLogoutRedirectUri: window.location.origin + '/landing',
    },
    cache: {
      cacheLocation: BrowserCacheLocation.SessionStorage,
    },
    system: {
      loggerOptions: { logLevel: LogLevel.Warning, piiLoggingEnabled: false },
    },
  });
}

export const msalGuardConfig: MsalGuardConfiguration = {
  interactionType:  InteractionType.Redirect,
  authRequest:      { scopes: AUTH_SCOPES.api },
  loginFailedRoute: '/landing',
};

export const msalInterceptorConfig: MsalInterceptorConfiguration = {
  interactionType: InteractionType.Redirect,
  protectedResourceMap: new Map([
    ['http://localhost:3000/api',      AUTH_SCOPES.api],
    ['https://ecs33budgets-api-hqabh0bef4bggugp.centralus-01.azurewebsites.net/api', AUTH_SCOPES.api],
  ]),
};